import {FC, useState} from "react";
import {useTranslation} from "react-i18next";
import {CloseIcon} from "../../icons";
import {
    TeamSubscribeBottomWrapper,
    TeamSubscribeCloseIconWrapper, TeamSubscribeContinueButton, TeamSubscribeEmailInput, TeamSubscribeRow, TeamSubscribeSuccessDesc,
    TeamSubscribeSuccessInfo,
    TeamSubscribeSuccessTitle,
    TeamSubscribeSuccessWrapper
} from "./styles";
import {setCookie} from "../../helpers/cookies";
import {LayoutConst, useModal} from "../../../core";
import {TEAM_SUBSCRIBE_STATUS_SEEN} from "./const";
import {useBreakpoint} from "@brg/ui";
import {API, Endpoints} from "@brg/api";

export const TeamSubscribe: FC = (props: any) => {
    const { teamName, teamContext } = props;

    const modal = useModal();
    const is744BP = useBreakpoint(LayoutConst.screen.s);

    const { t } = useTranslation()
    const [email, setEmail] = useState('')

    const onClose = (email?: string) => {

        if (email) {
            API.request()
                .endpoint(Endpoints.gateway)
                .url('/metrics/api/subscriber/Add')
                .body({
                    email: email,
                    pageUrl:  window.location.href,
                })
                .post()
                .send()
        }

        setCookie(TEAM_SUBSCRIBE_STATUS_SEEN + teamContext, 'true')
        modal.hide()
    }

    return (
        <TeamSubscribeSuccessWrapper>
            <TeamSubscribeSuccessInfo>
                <TeamSubscribeRow>
                    <TeamSubscribeSuccessTitle>{t("subscription.modal_team.title", { title: teamName })}</TeamSubscribeSuccessTitle>
                    {!is744BP && <TeamSubscribeCloseIconWrapper onClick={() => {
                        onClose()
                    }}>
                        <CloseIcon />
                    </TeamSubscribeCloseIconWrapper>}
                </TeamSubscribeRow>
                <TeamSubscribeBottomWrapper>
                    <TeamSubscribeEmailInput value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mail"/>
                    <TeamSubscribeContinueButton
                        disabled={email?.length === 0}
                        onClick={() => {
                            if (email?.length === 0) return
                            onClose(email)
                        }
                        }
                    >
                        {t("subscription.subscribe")}
                    </TeamSubscribeContinueButton>
                </TeamSubscribeBottomWrapper>
            </TeamSubscribeSuccessInfo>
        </TeamSubscribeSuccessWrapper>
    )
}import {FC, useState} from "react";
import {useTranslation} from "react-i18next";
import {CloseIcon} from "../../icons";
import {
    TeamSubscribeBottomWrapper,
    TeamSubscribeCloseIconWrapper, TeamSubscribeContinueButton, TeamSubscribeEmailInput, TeamSubscribeRow, TeamSubscribeSuccessDesc,
    TeamSubscribeSuccessInfo,
    TeamSubscribeSuccessTitle,
    TeamSubscribeSuccessWrapper
} from "./styles";
import {setCookie} from "../../helpers/cookies";
import {LayoutConst, useModal} from "../../../core";
import {TEAM_SUBSCRIBE_STATUS_SEEN} from "./const";
import {useBreakpoint} from "@brg/ui";
import {API, Endpoints} from "@brg/api";

export const TeamSubscribe: FC = (props: any) => {
    const { teamName, teamContext } = props;

    const modal = useModal();
    const is744BP = useBreakpoint(LayoutConst.screen.s);

    const { t } = useTranslation()
    const [email, setEmail] = useState('')

    const onClose = (email?: string) => {

        if (email) {
            API.request()
                .endpoint(Endpoints.gateway)
                .url('/metrics/api/subscriber/Add')
                .body({
                    email: email,
                    pageUrl:  window.location.href,
                })
                .post()
                .send()
        }

        setCookie(TEAM_SUBSCRIBE_STATUS_SEEN + teamContext, 'true')
        modal.hide()
    }

    return (
        <TeamSubscribeSuccessWrapper>
            <TeamSubscribeSuccessInfo>
                <TeamSubscribeRow>
                    <TeamSubscribeSuccessTitle>{t("subscription.modal_team.title", { title: teamName })}</TeamSubscribeSuccessTitle>
                    {!is744BP && <TeamSubscribeCloseIconWrapper onClick={() => {
                        onClose()
                    }}>
                        <CloseIcon />
                    </TeamSubscribeCloseIconWrapper>}
                </TeamSubscribeRow>
                <TeamSubscribeBottomWrapper>
                    <TeamSubscribeEmailInput value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mail"/>
                    <TeamSubscribeContinueButton
                        disabled={email?.length === 0}
                        onClick={() => {
                            if (email?.length === 0) return
                            onClose(email)
                        }
                        }
                    >
                        {t("subscription.subscribe")}
                    </TeamSubscribeContinueButton>
                </TeamSubscribeBottomWrapper>
            </TeamSubscribeSuccessInfo>
        </TeamSubscribeSuccessWrapper>
    )
}